import type { UppyFileUploadState } from '@/uppy-file-upload/store/slice'

/**
 * Adds the filenames of not-yet-failed queued/uploading files targeting `folderId` to
 * `occupiedNames`, so a batch drop doesn't re-use a name already claimed by an in-flight upload.
 */
export function addQueuedUploadFilenames(occupiedNames: Set<string>, uppyFileUploadState: UppyFileUploadState, folderId: string): void {
  Object.values(uppyFileUploadState.files)
    .filter((f) => f.client.folderId === folderId && f.client.uploadStatus !== 'error' && f.client.uploadStatus !== 'unsupported_type')
    .forEach((f) => occupiedNames.add(f.client.filename))
}
